import { Suspense } from 'react'
import { ToastBar, Toaster } from 'react-hot-toast'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { ExploreLearnings } from 'pages/exploreLearnings/ExploreLearnings'
import { SkillPage } from 'pages/exploreLearnings/pages/SkillPage'

export function App() {
  return (
    <BrowserRouter basename="/marketing-capabilities">
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<ExploreLearnings />} />

          <Route path="/explore-learnings/skill/:skillId" element={<SkillPage />} />
          <Route path="/explore-learnings/:section?" element={<ExploreLearnings />} />
          <Route path="*" element={<ExploreLearnings />} />
        </Routes>
      </Suspense>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{ top: 80, right: 64 }}
        toastOptions={{
          style: {
            padding: 0,
            margin: 0,
            background: 'transparent',
            boxShadow: 'none',
            maxWidth: '400px',
          },
        }}
      >
        {t => (
          <ToastBar
            toast={t}
            style={{
              ...t.style,
              animation: t.visible ? 'slideIn 0.3s ease-out forwards' : 'fadeOut 0.25s ease-in forwards',
            }}
          />
        )}
      </Toaster>
    </BrowserRouter>
  )
}
